// 结算管理
export default [
  {
    path: "/settlement",
    meta: { title: "结算管理" },
    component: () => import("../views/settlement/index.vue"),
    children: [
      {
        path: '/settlement/serviceList',
        meta: { title: '服务列表', isMenu: true },
        component: () => import('../views/settlement/serviceList'),
      },
      {
        path: '/settlement/projectOrder',
        meta: { title: '项目订单列表', isMenu: true },
        component: () => import('../views/settlement/projectOrder'),
      },
      {
        path: '/settlement/productOrder',
        meta: { title: '商品订单列表', isMenu: true },
        component: () => import('../views/settlement/productOrder'),
      },
      {
        path: '/settlement/detail/productOrderDetail',
        meta: { title: '商品订单明细详情' },
        component: () => import('../views/settlement/detail/productOrderDetail'),
      },

      {
        path: "/settlement/withdrawalApplication",
        meta: { title: "提现申请", isMenu: true },
        component: () => import("../views/settlement/withdrawalApplication.vue"),
      },
      {
        path: '/settlement/detail/accountManagement',
        meta: { title: '收款账号管理', },
        component: () => import('../views/settlement/detail/accountManagement.vue'),
      },
      {
        path: '/settlement/detail/applyDetail',
        meta: { title: '提现申请详情', },
        component: () => import('../views/settlement/detail/applyDetail.vue'),
      },

      {
        path: '/settlement/commission',
        meta: { title: '员工提成明细', isMenu: true },
        component: () => import('../views/settlement/commission'),
      },
    ],
  },
]
